import _ from 'lodash';

import * as Account from 'app/entities/Account';
import * as Zap from 'app/entities/Zap';

export const toAccountParam = 'toAccountId';
export const fromAccountParam = 'fromAccountId';

const getTransformedRouterParam = (transform, param, state) =>
  transform(_.get(state, ['router', 'current', 'params', param]));

const getNumericRouterParam = _.partial(getTransformedRouterParam, param =>
  parseInt(param, 10)
);

export const fromAccountIdParam = _.partial(
  getNumericRouterParam,
  fromAccountParam
);
export const toAccountIdParam = _.partial(
  getNumericRouterParam,
  toAccountParam
);

const getOtherAccountIdsWithMovableZaps = (id, state) =>
  _.without(Zap.selectors.all.accountsWithMovableZaps(state), id);

const getOnlyOtherAccountId = otherIds => {
  return otherIds.length > 1 ? null : otherIds[0];
};

export const buildFromToLink = (from, to) => {
  const fromPath = from ? `from/${from}/` : '';
  const toPath = to ? `to/${to}` : '';
  return `/app/move-zaps/${fromPath}${toPath}`.replace(/\/$/, '');
};

// Builds a from-to link where `to` is supplied and `from` is
// calculated based on other accounts' zap usage.
export const buildAutoFromLink = (to, state) => {
  const otherIds = getOtherAccountIdsWithMovableZaps(to, state) || [];
  const onlyOtherId = getOnlyOtherAccountId(otherIds);
  // If there are no `otherIds` then there isn't another account to move any zaps to.
  return otherIds.length === 0 ? null : buildFromToLink(onlyOtherId, to);
};

// Builds a from-to link where `from` is supplied and `to` is
// calculated based on other accounts.
export const buildAutoToLink = (from, state) => {
  const otherIds = _.without(Account.selectors.all.entitiesIds(state), from);
  const onlyOtherId = getOnlyOtherAccountId(otherIds);
  return otherIds.length === 0 ? null : buildFromToLink(from, onlyOtherId);
};
